import { createActions, createReducer } from 'reduxsauce';

export const { Types, Creators } = createActions({
  getParametrosRequest: [],
  success: ['success', 'message', 'data'],
  getError: ['error'],
  patchParametroRequest: ['idParametrizacao', 'data'],
  renew: [],
});

const INICIAL_STATE = {
  success: false,
  message: '',
  data: [],
  loading: false,
  error: null,
};

const getParametrosRequest = (state = INICIAL_STATE) => ({
  ...state,
  success: false,
  message: '',
  data: [],
  loading: false,
  error: null,
});

const success = (state = INICIAL_STATE, action) => ({
  ...state,
  success: action.success,
  message: action.message,
  data: action.data || [],
  loading: false,
  error: null,
});

const getError = (state = INICIAL_STATE, action) => ({
  ...state,
  success: false,
  loading: false,
  error: action.error,
});

const patchParametroRequest = (state = INICIAL_STATE, action) => {
  return {
    ...state,
    loading: true,
    error: null,
  };
};

const renew = (state = INICIAL_STATE) => ({
  ...state,
  ...INICIAL_STATE,
});

export default createReducer(INICIAL_STATE, {
  [Types.GET_ERROR]: getError,
  [Types.GET_PARAMETROS_REQUEST]: getParametrosRequest,
  [Types.PATCH_PARAMETRO_REQUEST]: patchParametroRequest,
  [Types.SUCCESS]: success,
  [Types.RENEW]: renew,
});
